import * as ErrorsActionTypes from '../../types/errors';

/**
 * Sets removed collaborator error
 * @param {boolean} payload
 */
export const setRemovedCollaboratorError = (payload) => ({
    type: ErrorsActionTypes.SET_REMOVED_COLLABORATOR_ERROR,
    payload
});
